// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table_tableWrapper__7BcSa","table":"Table_table__6sIvw","placeholder":"Table_placeholder__8qG8Z"};